/* unplugin-vue-components disabled */import script from "./GeoReport.vue?vue&type=script&lang=ts&setup=true"
export * from "./GeoReport.vue?vue&type=script&lang=ts&setup=true"

import "./GeoReport.vue?vue&type=style&index=0&id=6e9608f4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e9608f4"]])

export default __exports__